import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { getTrackingMethodText } from '../../eld-tracking/utils'

interface IAlertCarrierNotConnectedProps {
  trackingMethod?: TRACKING_METHOD_TYPE
}
/**
 * This component will soon replace AlertEnableLiveTracking.tsx
 */
export const AlertCarrierNotConnected: FC<IAlertCarrierNotConnectedProps> = ({
  trackingMethod,
}) => {
  const trackingMethodText = getTrackingMethodText(trackingMethod as TRACKING_METHOD_TYPE)
  const history = useHistory()

  const clickHandler = () => {
    history.push('/user/settings/integrations')
  }

  return (
    <Box data-test='alert-carrier-not-connected' component='span'>
      <strong>Please connect your {trackingMethodText} account.</strong> To track this load using
      your truck’s ELD, please
      <Button variant='text' noPadding onClick={clickHandler}>
        connect your carrier’s {trackingMethodText} account.
      </Button>{' '}
    </Box>
  )
}
